export const postUrls = {
  /**
   * 获取客流数据
   */
  getPassengerTraffic: '/service/getPassengerTraffic.action',
  /**
   * 获取客流排行
   */
  getTopRankHourly: '/service/getTopRankHourly.action',
  /**
   * 获取登录情况
   */
  getLoginStatus: '/service/countLogs.action',
  /**
   * 获取最近消息
   */
  getLastMeg: '/shopweb-support/task/taskModule/v2.0/getTaskByPeriod',
  /**
   * 删除一个card
   */
  deleteUserShopTag: '/service/deleteUserShopTag.action',
  /**
   * 保存定阅
   */
  saveUserShopTags: '/ovopark-organize/enterpriseTag/saveUserWebTags',
  /**
   * 获取我自定义的菜单
   */
  getMyMenus: '/shopweb-support/module/getUserWebModules',
  /**
   * 保存我的常用菜单
   */
  saveMyMenus: '/shopweb-support/module/saveUserWebModules',
  /*
    获取店长数据中心数据
   */
  getDataForDep: '/shopweb-passengerflow/customerFlow/getHomePageForDep',
  /*
    获取督导数据中心数据
   */
  getDataForArea: '/shopweb-ipos/sales/getHomePageForArea',
  /*
    获取高管数据中心数据
   */
  getDataForGroup: '/shopweb-ipos/sales/getHomePageForGroup',
  /**
   * 金币 获取门店排行
   */
  getUserGoldRankingByDepByPage: {
    url: '/shopweb-support/gold/getUserGoldRankingByDepByPage',
    catch: true,
  },

  /**
   * 金币 获取个人排行
   */
  getUserGoldRankingByUserByPage: {
    url: '/shopweb-support/gold/getUserGoldRankingByUserByPage',
    catch: true,
  },

  /**
   * 门店暗访检查项大类得分率
   */
  getParentClassReport: '/shopweb-detect-business/shopDetect/getParentClassReport',
  /**
   *  终审配置获取
   */
  getReviewConfig: '/shopweb-detect-business/reviewConfig/getReviewConfig',

  /**
   * 获取企业配置(新接口)
   * @param groupId 企业id
   */
  getEnterpriseConfigNew: '/ovopark-organize/enterprise/getEnterpriseConfigg',

  /**
   * 获取热点设备
   */
  getHotListDevice: '/shopweb-hotspot/hotspotFiltration/listHotspotDevice',

  /**
   * 获取热点图片
   */
  getHotPic: '/shopweb-hotspot/hotspot/getDeviceHotspot',

  /**
   * 获取热点坐标
   */
  getHotCoord: '/shopweb-hotspot/hotspot/getDeviceHotspotZone',
  /**
   * 获取客流均值
   */
  getMeanAnalysisTrend:'/shopweb-passengerflow/descente/getMeanAnalysisTrend',
};

export const postJsons = {
  //  巡店基本情况
  shopBaseSummary: '/check-report/dashboard/shopBaseSummary',
  // 不合格点检项
  evaluationUnqualifiedRateTop: '/check-report/dashboard/evaluationUnqualifiedRateTop',
  // 代办单进度
  problemProgressSummary: '/check-report/dashboard/problemProgressSummaryPage',
  //  门店得分
  pageShopScore: {
    url: '/check-report/dashboard/pageShopScore',
    catch: true,
  },
  getStartTimeDistributionConfig: '/shopweb-check/visualize-config/getStartTimeDistributionConfig',
  getStartTimeDistribution: '/check-report/dashboard/getStartTimeDistribution',
  /**
   * 门店暗访得分排行
   */
  getShopRank: {
    url: '/shopweb-detect-business/shopDetect/getShopRank',
    catch: true,
  },
  /**
   * 获取视频流
   */
  startNewMediaPlay: '/ovopark-device/video/startNewMediaPlay',
  /**
   * 保存用户订阅模块 迁移后新接口
   */
  saveUserWebModules: '/ovopark-privilege/module/saveUserWebModules',
};

export const getUrls = {
  /**
   * 获取近7天数据
   */
  getDataOfLastSevenDays: '/ovopark-organize/mobile/getDataOfLastSevenDays',
  /**
   * 获取代办单概况
   */
  getTodoList: '/shopweb-check/problem/getEnterpriseProblemNum',
  /**
   * 获取用户所有可以自定义的标签
   */
  getAllUserTags: '/ovopark-organize/enterpriseTag/getNewEnterpriseTags',
  /**
   * 获取模块列表
   */
  getModules: '/ovopark-organize/enterpriseTag/getUserWebTags',
  /**
   * 近7日数据-客流数新接口
   * param{ num:近n天 }默认7天
   */
  getFlowData: '/shopweb-passengerflow/web/getNearlyNDaysFlowAndSale',

  /**
   * 新接口-客流排行
   * timeType：2 天，topNum：5默认
   */
  getFlowRank: '/shopweb-passengerflow/web/getFlowRank',
  /**
   * 新接口-近7日客流销售额趋势
   * num：7默认
   */
  getFlowTrend: '/shopweb-passengerflow/web/getNearlyNDaysFlowAndSaleTrend',
  /**
   * 获取设备概况
   */
  getDeviceStatistics: '/ovopark-device/device-report/getDeviceStatistics',
  /**
   * 获取申诉流程、申诉时间
   * @param enterpriseId 企业id
   */
  getAppealFlow: '/shopweb-check/claim-conduct/find-claim-config',
  /**
   * 获取申诉+整改流程、申诉时间
   * @param enterpriseId 企业id
   */
  getDoubleFlow: '/shopweb-check/claimReformConfig/findConfig',
  saveStartTimeDistributionConfig: '/shopweb-check/visualize-config/saveStartTimeDistributionConfig',

  /**
   * 获取登录情况
   */
  countLogsNew: '/ovopark-organize/loginLog/countLogs',
  /**
   * 获取大屏背景图
   */
  getBackgroundUrls: '/ovopark-organize/enterpriseTag/getBackgroundUrls',

  /**
   * oa审批的数量统计
   */
  getFlowInstanceCount: '/ovopark-approval-flow/flowInstance/count',
  /**
   * 任务概览页当月统计
   */
  taskModuleCount: '/task/taskModule/v2/count',
  /**
   * 暗访检查项得分分布
   */
  getShopScoreRate: '/shopweb-detect-business/shopDetect/getShopScoreRate',
  /**
   *
   */
  queryAbnormalTaskLogList: '/aicheck-service/api/aicheck/taskLog/v1/queryAbnormalTaskLogList',

  /**
   * 获取用户订阅模块 迁移后新接口
   */
  getUserWebModules: '/ovopark-privilege/module/getUserWebModules',
  /**
   * 获取收藏门店详情
   */
  getFavoriteTagDetail: '/ovopark-organize/enterpriseTag/getFavoriteTagDetail',
  /**
   * 获取最近观看详情--门店维度
   */
  getRecentViewTagDetail: '/ovopark-organize/enterpriseTag/getRecentViewTagDetail',

  /**
   * 获取最近观看详情--设备维度
   */
  getUserRecentViewDetail: '/eventhub-control/device-log/user/latest',

  /**
   * 获取精准客流--性别年龄
   */
  getAccurateAgeSex: '/shopweb-passengerflow/flowGroup/getPersonalizationAgeGroupAndGenderDistribution',

  /**
   * 获取功能上新推广模块
   */
  getPromotedModules: '/ovopark-privilege/promotion/getPromotedModules',
};
